import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { SystemText } from 'e4shared';

const Chart = ({ data, keys }) => (
    <ResponsiveBar
        data={data}
        keys={keys}
        margin={{ top: 10, right: 130, bottom: 50, left: 60 }}
        padding={0.2}
        innerPadding={2}
        groupMode="grouped"
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        valueFormat={{ format: ' >-', enabled: false }}
        colors={{ scheme: 'nivo' }}
        borderRadius={2}
        borderWidth={1}
        borderColor={{ from: 'color', modifiers: [['darker', '0.5']] }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: SystemText('Dashboard/Widgets/RampTimes/AvgTimeTo'),
            legendPosition: 'middle',
            legendOffset: 40,
        }}
        axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: SystemText('Dashboard/Widgets/RampTimes/Days'),
            legendPosition: 'middle',
            legendOffset: -40,
        }}
        enableLabel={false}
        labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
        legends={[
            {
                dataFrom: 'keys',
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1,
                        },
                    },
                ],
            },
        ]}
    />
);

export default Chart;
